var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-homepage__videos-carousel-wrapper" }, [
    _c(
      "div",
      {
        ref: "selectedVideo",
        staticClass:
          "c-homepage__videos-carousel-current c-homepage__videos-carousel-current--video",
      },
      [
        _vm.selectedVideo
          ? _c(
              "div",
              {
                key: _vm.selectedVideo.ID,
                staticClass: "c-homepage__videos-selected-wrapper",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-homepage__videos-carousel-embed-container",
                    style: {
                      backgroundImage:
                        "url(" + _vm.selectedVideo.Thumbnail + ")",
                    },
                  },
                  [
                    _c("iframe", {
                      attrs: {
                        src: _vm.getVideoEmbedURL(_vm.selectedVideo.VideoURL),
                        frameborder: "0",
                        allowfullscreen: "",
                      },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-homepage__videos-thumbnail-carousel" },
      _vm._l(_vm.currentVideos, function (video, index) {
        return _c(
          "div",
          {
            key: video.ID,
            class: [
              "c-homepage__videos-thumb",
              {
                "c-homepage__videos-thumb--active": _vm.selectedVideo === video,
              },
            ],
            on: {
              click: function ($event) {
                return _vm.selectVideo(index)
              },
            },
          },
          [
            _c("img", {
              staticClass: "c-homepage__videos-thumb-img",
              attrs: { src: video.Thumbnail, alt: "Thumbnail" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "c-homepage__videos-video-title" }, [
              _vm._v(_vm._s(video.Title)),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "c-homepage__videos-carousel-current c-homepage__videos-carousel-current--text",
      },
      [
        _vm.selectedVideo
          ? _c(
              "div",
              { staticClass: "c-homepage__videos-selected-wrapper" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.selectedVideo.Title))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.selectedVideo.Description))]),
                _vm._v(" "),
                _vm.selectedVideo.Link && _vm.selectedVideo.Link.LinkURL
                  ? [
                      _c(
                        "a",
                        {
                          staticClass: "readmore readmore__linkBox",
                          attrs: {
                            href:
                              _vm.selectedVideo.Link.LinkURL +
                              (_vm.selectedVideo.Link.Anchor
                                ? "#" + _vm.selectedVideo.Link.Anchor
                                : ""),
                            target: _vm.selectedVideo.Link.OpenInNewWindow
                              ? "_blank"
                              : "_self",
                          },
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.selectedVideo.Link.Title)),
                          ]),
                          _vm._v(" "),
                          _c("span"),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    !_vm.isSmallScreen
      ? _c("div", { staticClass: "c-homepage__videos-carousel-controls" }, [
          _c(
            "button",
            {
              staticClass:
                "c-homepage__videos-carousel-control c-homepage__videos-carousel--prev",
              class: {
                "c-homepage__videos-carousel-control--disabled":
                  _vm.disablePrev,
              },
              attrs: { disabled: _vm.disablePrev },
              on: {
                click: function ($event) {
                  return _vm.prev()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "c-homepage__videos-carousel-control-icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    width: "24",
                    height: "24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M12 4.5l-8.5 8.5 1.41 1.41L12 7.83l7.09 7.08L20.5 13z",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "c-homepage__videos-carousel-control c-homepage__videos-carousel--next",
              class: {
                "c-homepage__videos-carousel-control--disabled":
                  _vm.disableNext,
              },
              attrs: { disabled: _vm.disableNext },
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "c-homepage__videos-carousel-control-icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    width: "24",
                    height: "24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M12 19.5l8.5-8.5-1.41-1.41L12 16.17l-7.09-7.08L3.5 11z",
                    },
                  }),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }